
function playVideo(video,playbtn) {
    let bannerWrapper = video.closest('.banner');

    if(playbtn.classList.contains('active')){
        video.pause();
        playbtn.classList.remove('active');
        video.closest('.videoplaywrapper').classList.remove('active');
        if(bannerWrapper){
            bannerWrapper.querySelector('.bannerTextRight').style.display = "";
        }
    }else{
        video.play();
        playbtn.classList.add('active');
        video.closest('.videoplaywrapper').classList.add('active');
        if(bannerWrapper && window.innerWidth >= 768){
            bannerWrapper.querySelector('.bannerTextRight').style.display = "none";
        }
    }
}

function muteVideo(video,mutebtn) {
    if(video.muted){
        video.muted = false;
        mutebtn.classList.remove('active');
    }else{
        video.muted = true;
        mutebtn.classList.add('active');
    }
}

export function generateMuteButton(video) {
    let bannerWrapper = video.closest('.mbBanner');
    if(bannerWrapper){
        let mutebutton = document.createElement('div');
        mutebutton.classList.add('mutebtn');
        mutebutton.classList.add('active');
        mutebutton.innerHTML = "<i class='icon icon-volume-off'></i>";
        bannerWrapper.appendChild(mutebutton);

        mutebutton.addEventListener('click',function () {
            muteVideo(video,mutebutton);
        });
    }
}


export function setSrcVideos() {
    const windowWidth = window.outerWidth;

    for (let video of document.querySelectorAll('video')) {
        for (let videoSource of video.querySelectorAll('source')) {
            let src = false;
            let srcDesktop = videoSource.dataset.src;
            let srcTablet = videoSource.dataset.tabletSrc;
            let srcMobile = videoSource.dataset.mobileSrc;

            if (srcDesktop !== undefined) {
                src = srcDesktop;
            }
            if (windowWidth < 1250 && srcTablet !== undefined) {
                src = srcTablet;
            }
            if (windowWidth < 768 && srcMobile !== undefined) {
                src = srcMobile;
            }

            if (src !== false) {
                videoSource.setAttribute('src', src);
            }
        }
        video.load();
    }
}